import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '../styles/Profile.css';

const Notifications = () => {
  // const { user } = useSelector(state => state.auth);
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, likes, comments, follows

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `http://localhost:5000/api/notifications?type=${filter === 'all' ? '' : filter}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setNotifications(response.data);
      } catch (error) {
        console.error('Error loading notifications:', error);
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, [filter]);

  const getNotificationIcon = (type) => {
    const icons = {
      like: '❤️',
      comment: '💬',
      follow: '👥',
      mention: '@',
      message: '📨',
    };
    return icons[type] || '📢';
  };

  const getNotificationColor = (type) => {
    const colors = {
      like: '#ff6b6b',
      comment: '#4ecdc4',
      follow: '#1dd1a1',
      mention: '#ffd93d',
      message: '#6c5ce7',
    };
    return colors[type] || '#888';
  };

  const filteredNotifications =
    filter === 'all'
      ? notifications
      : notifications.filter(n => n.type === filter);

  const unreadCount = notifications.filter(n => !n.read).length;

  const formatTime = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return t('notifications.justNow');
    if (minutes < 60) return `${minutes}${t('notifications.minutesAgo')}`;
    if (hours < 24) return `${hours}${t('notifications.hoursAgo')}`;
    if (days < 7) return `${days}${t('notifications.daysAgo')}`;
    return new Date(date).toLocaleDateString();
  };

  return (
    <div className="profile-container" style={{ maxWidth: '600px', margin: '2rem auto' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          🔔 {t('notifications.title')}
          {unreadCount > 0 && (
            <span
              style={{
                background: '#ff6b6b',
                color: 'white',
                padding: '0.25rem 0.75rem',
                borderRadius: '20px',
                fontSize: '0.9rem',
                fontWeight: 'bold',
              }}
            >
              {unreadCount}
            </span>
          )}
        </h1>
      </div>

      {/* Filter buttons */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
        {['all', 'likes', 'comments', 'follows'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f === 'likes' ? 'like' : f === 'comments' ? 'comment' : f === 'follows' ? 'follow' : 'all')}
            style={{
              padding: '0.5rem 1rem',
              background: (filter === 'all' && f === 'all') || filter === (f === 'likes' ? 'like' : f === 'comments' ? 'comment' : f === 'follows' ? 'follow' : 'all')
                ? '#1dd1a1'
                : 'rgba(29, 209, 161, 0.1)',
              border: '1px solid #1dd1a1',
              color: 'white',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              textTransform: 'capitalize',
            }}
          >
            {t(`notifications.${f}`)}
          </button>
        ))}
      </div>

      {/* Notifications list */}
      {loading ? (
        <div style={{ textAlign: 'center', color: '#888' }}>{t('common.loading')}...</div>
      ) : filteredNotifications.length > 0 ? (
        <div>
          {filteredNotifications.map(notif => (
            <div
              key={notif._id}
              style={{
                background: notif.read
                  ? 'rgba(29, 209, 161, 0.05)'
                  : 'rgba(29, 209, 161, 0.15)',
                border: `1px solid rgba(29, 209, 161, ${notif.read ? '0.1' : '0.3'})`,
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                display: 'flex',
                gap: '1rem',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(29, 209, 161, 0.2)';
                e.currentTarget.style.borderColor = '#1dd1a1';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = notif.read
                  ? 'rgba(29, 209, 161, 0.05)'
                  : 'rgba(29, 209, 161, 0.15)';
                e.currentTarget.style.borderColor = `rgba(29, 209, 161, ${notif.read ? '0.1' : '0.3'})`;
              }}
            >
              {/* Avatar */}
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: notif.actor.profilePicture ? 'transparent' : getNotificationColor(notif.type),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '1.2rem',
                  overflow: 'hidden',
                  flexShrink: 0,
                }}
              >
                {notif.actor.profilePicture ? (
                  <img
                    src={`http://localhost:5000${notif.actor.profilePicture}`}
                    alt={notif.actor.username}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <>{notif.actor.firstName?.charAt(0)}{notif.actor.lastName?.charAt(0)}</>
                )}
              </div>

              {/* Notification content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <span style={{ color: '#1dd1a1', fontSize: '1.2rem' }}>
                    {getNotificationIcon(notif.type)}
                  </span>
                  <strong style={{ color: 'white' }}>
                    {notif.actor.firstName} {notif.actor.lastName}
                  </strong>
                  <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                    @{notif.actor.username}
                  </span>
                </div>
                <div style={{ color: 'rgba(255, 255, 255, 0.8)', marginBottom: '0.5rem' }}>
                  {notif.message}
                </div>
                <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.85rem' }}>
                  {formatTime(notif.createdAt)}
                </div>
              </div>

              {/* Unread indicator */}
              {!notif.read && (
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    background: '#1dd1a1',
                    flexShrink: 0,
                  }}
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', color: '#888', padding: '2rem' }}>
          {t('notifications.noNotifications')} 🤷
        </div>
      )}
    </div>
  );
};

export default Notifications;
